import { useTranslations } from 'next-intl'

import classNames from 'classnames'

import Button, {
  ButtonTypes,
  ButtonVariants,
} from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { multiPostHogEventPusher } from '~/utils/analyticsPusher'

import type { PartnerResultsCardProps } from '../PartnerResultsCard/PartnerResultsCard'
import PartnerResultsCard from '../PartnerResultsCard/PartnerResultsCard'

import styles from './PartnerResults.module.css'

export interface PartnerResultsProps {
  canLoadMore: boolean
  loadMoreHandler: () => void
  title?: string
  partners?: PartnerResultsCardProps[]
}

export default function PartnerResults({
  canLoadMore,
  loadMoreHandler,
  title = 'results',
  partners,
}: PartnerResultsProps) {
  const t = useTranslations('common')
  return (
    <>
      <div className={classNames(styles.base)}>
        <Container>
          <div className={styles.header}>
            <Text size={TextSizes.primaryTitleSml}>
              {partners && partners.length > 0
                ? `${partners.length} ${title}`
                : `No results found`}
            </Text>
          </div>

          <div className={styles.partnerResults}>
            {partners?.map((partner, idx) => {
              const isAccredited = partner.type === 'accredited'
              const cardClass = isAccredited ? styles.accreditedCard : ''
              return (
                <div className={cardClass} key={`partner-portrait-${idx}`}>
                  <PartnerResultsCard
                    {...partner}
                    theme="light"
                    portrait={!isAccredited}
                    bordered={isAccredited}
                  />
                </div>
              )
            })}
          </div>

          {canLoadMore && (
            <div className={styles.footer}>
              <Button
                iconLeft
                button={{
                  type: ButtonTypes.button,
                  onClick: async () => {
                    loadMoreHandler()
                    await multiPostHogEventPusher([
                      {
                        eventType: 'Partners: Load more clicked',
                      },
                    ])
                  },
                }}
                variant={ButtonVariants.secondaryDark}
              >
                {t('loadMore')}
              </Button>
            </div>
          )}
        </Container>
      </div>
    </>
  )
}
